import React, {useEffect, useState} from "react";
import {LogOut} from "../domains/common/components/Head";
import {Button, CircularProgress, Grid, IconButton, Link, useTheme} from "@mui/material";
import Box from "@mui/material/Box";
import {PersonForm} from "./deal/components/PersonForm";
import {Item} from "../domains/common/components/Item";
import DeleteIcon from "@mui/icons-material/Delete";
import {IndentSpace, Link1, Title4, Title5} from "../domains/common/components/Typography";
import {Notify} from "../domains/common/components/AlertNotify";
import {DealTypesMapping, exceptionsTitle, RolesTitleSingular, subjectTypeSelect} from "../dictionaries";
import {SubjectType} from "../enums";
import {OrganizationForm} from "./deal/components/OrganizationForm";
import FormSelect from "../domains/common/components/FormSelect";
import {
  checkEdsInSignme, deleteSignMeDocument,
  signmeActivate,
  signmeDeleteRegistrationPerson,
  signmeRegistrationPerson, uploadRegistrationDocs, uploadSignMeDocument
} from "../domains/sign/signme";
import {createSubject, getSubject, updateSubject} from "../domains/subject";
import {loadUserOptions, userOptions} from "../user";
import {BackButtonToClientsList, BackButtonToDeal, ButtonBase, ButtonUpload} from "../domains/common/components/Button";
import {dealData} from "./deal/deal";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { SubjectSignmeSignature } from '../domains/sign/components/SignmeComponents';
import { SubjectMydssSignatureComponent } from '../domains/sign/components/MydssComponents';
import { CustomTabPanel } from '../domains/common/components/Tabs';
import { SubjectDealsList } from '../domains/subject/components/SubjectDealsList';

const queryParameters = new URLSearchParams(window.location.search)
const urlQuerySubjectId = queryParameters.get("id")
const urlQueryFromDealId = queryParameters.get("fd")

export default function SubjectPage() {
  const [signatureForm, setSignatureForm] = useState('');
  const [headProgressBar, setHeadProgressBar] = useState(false);
  const [state, setState] = useState()
  const [notify, openNotify] = Notify({open: false});
  const [activeTab, setActiveTab] = useState(0);

  const theme = useTheme();

  const getSubjectData = async () => {
    await loadUserOptions()

    if (urlQuerySubjectId) {
      setHeadProgressBar(true);
      const response = await getSubject(urlQuerySubjectId);

      if (response.ok) {
        setState(response.data);

        dealData.participants.push(response.data)
      }

      setHeadProgressBar(false);
    } else {
      setState({subjectId: 0});
    }
  }

  const handleSelectType = async (e) => {
    const result = await createSubject({type: e.target.value})

    if(result.ok) {
      const url = new URL(window.location.href);
      url.searchParams.set('id', result.data.subjectId);
      window.history.replaceState(null, null, url);

      dealData.participants.push({
        subjectId: result.data.subjectId,
        type: e.target.value
      })

      setState({type: e.target.value, subjectId: result.data.subjectId});
    } else {
      openNotify({
        msg: "Неудалось создать нового клиента",
        duration: 5000,
        type: 'error'
      })
    }
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    getSubjectData();
  }, []);

  const savePersonForm = async (e) => {
    if (!state?.subjectId) {
      openNotify({msg: "Ошибка создания участника. Обратитесь в техническую поддержку.", duration: 4000, errors: response.errors, type: 'error'})
    } else {
      const result = await updateSubject({...dealData.participants[0]});
      if (result.ok) {
        openNotify({
          msg: exceptionsTitle[result.message] || "Данные успешно сохранены",
          duration: 2000,
          type: 'success'
        })
      } else {
        openNotify({
          msg: exceptionsTitle[result.message] || "Ошибка сохранения",
          duration: 2000,
          errors: result.errors,
          type: 'error'
        })
      }
    }
  }

  return (
    <Box sx={{
      width: "100%",
      minHeight: '100%',
      backgroundColor: theme.palette.background.secondary
    }}>
      {notify}
      <Grid container spacing={0} wrap="nowrap" sx={{overflow: "auto", backgroundColor: theme.palette.background.secondary, pt: '4px', pb: '50px'}}>
        <Grid item xs={2} sx={{backgroundColor: theme.palette.background.secondary, minWidth: '80px'}}>
          {urlQueryFromDealId ? <BackButtonToDeal dealId={urlQueryFromDealId}/> : <BackButtonToClientsList />}
        </Grid>
        <Grid item xs={8} sx={{minWidth: '1280px',  backgroundColor: theme.palette.background.secondary}}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Item>
                {
                  !state?.type ? <SelectSubjectType onChange={handleSelectType}/> : void 0
                }
                {
                  state?.type === SubjectType.ORGANIZATION ?
                    <OrganizationForm className={`subjectForm${state.subjectId}`} values={state}
                                      personId={state.subjectId}></OrganizationForm> : void 0
                }
                {
                  state?.type === SubjectType.PERSON ?
                    <PersonForm values={state}></PersonForm> : void 0
                }
                <p/>
                <ButtonBase variant="contained" onClick={savePersonForm} size="small">Сохранить</ButtonBase>
              </Item>
            </Grid>
            <Grid item xs={6}>
              <Item sx={{pt: '5px'}}>

                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={handleTabChange} aria-label="basic tabs example">
                      <Tab label="Сделки" {...tabProps(0)} />
                      {state?.type === SubjectType.PERSON ? <Tab label="Выпустить SignMe" {...tabProps(1)} disabled={state?.configs?.isSignMeDisabled}/> : null}
                      {state?.type === SubjectType.PERSON ? <Tab label="Выпустить MyDSS" {...tabProps(2)} disabled={state?.configs?.isMyDSSDisabled}/> : null}
                    </Tabs>
                  </Box>
                  <Box style={{height: 20}}></Box>
                  <CustomTabPanel value={activeTab} index={0}>
                    <SubjectDealsList data={state?.deals}/>
                  </CustomTabPanel>
                  <CustomTabPanel value={activeTab} index={1}>
                    <SubjectSignmeSignature subjectId={state?.subjectId} />
                  </CustomTabPanel>
                  <CustomTabPanel value={activeTab} index={2}>
                    <SubjectMydssSignatureComponent subjectId={state?.subjectId} />
                  </CustomTabPanel>

              </Item>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2} sx={{backgroundColor: theme.palette.background.secondary, minWidth: '80px'}}>
          <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-end"><LogOut/></Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export function SelectSubjectType({className, values, onChange}) {
  return (
    <Grid item xs={12} container spacing={0}>
      <Grid item xs={12}><Title4 title="Тип клиента"/></Grid>
      <Grid item xs={6}><FormSelect data={subjectTypeSelect} label="Тип" minWidth="400"
                                    className={className}
                                    value={values?.type}
                                    onChange={onChange}
                                    name="type"/></Grid>
    </Grid>
  )
}